import PropTypes from "prop-types";
import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { IMaskInput } from "react-imask";

import CustomTextField from "./text-field";

export default function AmountField({ rules = {} }) {
  const { control } = useFormContext();

  return <Controller name="cash-amount" control={control} rules={rules} render={ControlledAmountField} />;
}

const ControlledAmountField = ({ field }) => {
  return (
    <div className="amount-field">
      <TextField
        {...field}
        placeholder="$0.00"
        autoFocus
        inputProps={{ mask: "$num" }}
        InputProps={{
          inputComponent: AmountFieldMaskAdapter,
        }}
      />
    </div>
  );
};

export const AmountFieldMaskAdapter = React.forwardRef((props, ref) => {
  const { onChange, value, max, mask, ...other } = props;

  return (
    <IMaskInput
      {...other}
      value={value?.masked}
      mask={mask}
      blocks={{
        num: {
          mask: Number,
          scale: 2,
          thousandsSeparator: ",",
          padFractionalZeros: true,
          normalizeZeros: true,
          radix: ".",
          min: 0,
          max: max,
        },
      }}
      inputRef={ref}
      onAccept={(value, maskRef) => onChange?.(!!value ? { masked: value, unmasked: maskRef.unmaskedValue } : null)}
    />
  );
});

AmountField.prototype = { rules: PropTypes.object };

export const RegularAmountField = ({ name, rules, disabled = false, textFieldProps = {} }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      disabled={disabled}
      render={({ field, fieldState }) => (
        <CustomTextField
          label="Base Rent"
          {...field}
          {...textFieldProps}
          errorMessage={fieldState?.error?.message}
          error={!!fieldState?.error}
          inputProps={{ mask: "num" }}
          InputProps={{
            inputComponent: AmountFieldMaskAdapter,
            startAdornment: (
              <InputAdornment position="start">
                <span className="text-lg-medium color--mist">$</span>
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
};
